import axios from '@/services/axios'

export default {
    getAllCategory(source) {
        return axios.get(`/intro/getAllCategory`, { cancelToken: source.token });
    },

    getCategorySearchVolTrends(params, source) {
        return axios.post(`/intro/getCategorySearchVolTrends`, params, { cancelToken: source.token });
    },

    getBrandSearchVolTrends(params, source) {
        return axios.post(`/intro/getBrandSearchVolTrends`, params, { cancelToken: source.token });
    },

    getPropSearchVolTrends(params, source) {
        return axios.post(`/intro/getPropSearchVolTrends`, params, { cancelToken: source.token });
    },

    getPropDetailSearchVolTrends(params, source) {
        return axios.post(`/intro/getPropDetailSearchVolTrends`, params, { cancelToken: source.token });
    },

    // 광고 유입 기록
    logAdVisit(params) {
        return axios.post(`/intro/logAdVisit`, params);
    },

    // 무료 체험 신청 (응답 data: "APPLIED" | "ALREADY_APPLIED")
    applyFreeTrial(params) {
        return axios.post(`/intro/applyFreeTrial`, params);
    },
}